module.exports = __webpack_public_path__ + "img/dibu_bg.3ff2a78b.png";